import { TagVariant } from '@optimus-web/core';
import {
    CreditCardState,
    PaymentMethodType,
    PaymentSettlementState,
    PayoutDetailResultType,
    SepaDirectDebitProviderState,
    TransactionHistoryItemType,
} from '@mews-commander/data-access';
import { PaymentMethodImageType } from '@mews/business-components';
import { TextKey } from '@mews-commander/enums';

export const paymentSettlementStateTagVariantMap: Record<PaymentSettlementState, TagVariant> = {
    [PaymentSettlementState.Unsettled]: 'basicBold',
    [PaymentSettlementState.Settled]: 'basicBold',
};

export const creditCardStateTagVariantMap: Record<CreditCardState, TagVariant> = {
    [CreditCardState.Enabled]: 'primary',
    [CreditCardState.Disabled]: 'warning',
};

export const sepaStateTagVariantMap: Record<SepaDirectDebitProviderState, TagVariant> = {
    [SepaDirectDebitProviderState.Enabled]: 'primary',
    [SepaDirectDebitProviderState.Disabled]: 'warning',
};

export const paymentMethodImageTypeMap: Record<PaymentMethodType, PaymentMethodImageType> = {
    [PaymentMethodType.Ideal]: PaymentMethodImageType.Ideal,
    [PaymentMethodType.PaymentCard]: PaymentMethodImageType.PaymentCard,
    [PaymentMethodType.ApplePay]: PaymentMethodImageType.ApplePay,
    [PaymentMethodType.GooglePay]: PaymentMethodImageType.GooglePay,
    [PaymentMethodType.SepaDirectDebit]: PaymentMethodImageType.SepaDirectDebit,
    [PaymentMethodType.Other]: PaymentMethodImageType.PaymentCard,
};

export const hasLinkedPayment: Record<PayoutDetailResultType, boolean> = {
    [PayoutDetailResultType.Charge]: true,
    [PayoutDetailResultType.CommissionAdjustment]: true,
    [PayoutDetailResultType.Refund]: true,
    [PayoutDetailResultType.ChargeBack]: true,
    [PayoutDetailResultType.ChargebackReversal]: true,
    [PayoutDetailResultType.PlatformFee]: false,
    [PayoutDetailResultType.BalanceTopUp]: false,
    [PayoutDetailResultType.Payout]: false,
};

export const transactionHistoryItemTypeTitleLabelMap: Record<TransactionHistoryItemType, Mews.TextKey> = {
    [TransactionHistoryItemType.Other]: TextKey.PayoutDetailUndefinedTransactionType,
    [TransactionHistoryItemType.MewsPaymentCommissionChargeback]: TextKey.PayoutDetailMewsPaymentCommissionTitle,
    [TransactionHistoryItemType.MewsPaymentCommissionChargebackReversal]:
        TextKey.PayoutDetailMewsPaymentCommissionTitle,
    [TransactionHistoryItemType.MewsPaymentCommissionRefund]: TextKey.PayoutDetailMewsPaymentCommissionTitle,
    [TransactionHistoryItemType.MewsPaymentCommission]: TextKey.PayoutDetailMewsPaymentCommissionTitle,
    [TransactionHistoryItemType.Refund]: TextKey.PayoutDetailRefundTitle,
    [TransactionHistoryItemType.PartialRefund]: TextKey.PayoutDetailPartialRefundTitle,
    [TransactionHistoryItemType.GrossAmount]: TextKey.PayoutDetailGrossAmountTitle,
    [TransactionHistoryItemType.Chargeback]: TextKey.PayoutDetailChargebackTitle,
    [TransactionHistoryItemType.ChargebackReversal]: TextKey.PayoutDetailChargebackReversalTitle,
    [TransactionHistoryItemType.PositiveCommissionAdjustment]: TextKey.PayoutDetailCommissionAdjustmentTitle,
    [TransactionHistoryItemType.NegativeCommissionAdjustment]: TextKey.PayoutDetailCommissionAdjustmentTitle,
};

export const transactionHistoryItemTypeDescriptionLabelMap: Record<TransactionHistoryItemType, Mews.TextKey> = {
    [TransactionHistoryItemType.Other]: TextKey.PayoutDetailUndefinedTransactionType,
    [TransactionHistoryItemType.MewsPaymentCommissionChargeback]:
        TextKey.PayoutDetailMewsPaymentCommissionChargebackDescription,
    [TransactionHistoryItemType.MewsPaymentCommissionChargebackReversal]:
        TextKey.PayoutDetailMewsPaymentCommissionChargebackReversalDescription,
    [TransactionHistoryItemType.MewsPaymentCommissionRefund]:
        TextKey.PayoutDetailMewsPaymentCommissionRefundDescription,
    [TransactionHistoryItemType.MewsPaymentCommission]: TextKey.PayoutDetailCommissionAdjustmentDescription,
    [TransactionHistoryItemType.Refund]: TextKey.PayoutDetailRefundDescription,
    [TransactionHistoryItemType.PartialRefund]: TextKey.PayoutDetailPartialRefundDescription,
    [TransactionHistoryItemType.GrossAmount]: TextKey.PayoutDetailGrossAmountDescription,
    [TransactionHistoryItemType.Chargeback]: TextKey.PayoutDetailChargebackDescription,
    [TransactionHistoryItemType.ChargebackReversal]: TextKey.PayoutDetailChargebackReversalDescription,
    [TransactionHistoryItemType.PositiveCommissionAdjustment]:
        TextKey.PayoutDetailPositiveCommissionAdjustmentDescription,
    [TransactionHistoryItemType.NegativeCommissionAdjustment]:
        TextKey.PayoutDetailNegativeCommissionAdjustmentDescription,
};
